import React from 'react'
import type { Icon } from 'shared/utils'

const Card = (props: Icon) => {
    const { color = 'black', size = 24, className = 'card' } = props
    return (
        <svg className={className} width={size} height={size} fill={color}>
            <path
                fillRule="evenodd"
                d="M15.447 2.71v2.209H7.02l8.427-2.21zm1.64 2.209h-.98V2.668c0-.405-.234-.667-.554-.667a.596.596 0 0 0-.19.02l-9.619 2.58A1.162 1.162 0 0 0 5 5.685V21.09a.875.875 0 0 0 .871.866H17.13a.875.875 0 0 0 .873-.866V5.77a.927.927 0 0 0-.915-.851z"
            />
        </svg>
    )
}

export { Card }
